export default __webpack_public_path__ + "static/home-5dba38cd1338acd00cb6b45e20d0d011.png";